<template>
    <div class="container-frame flex h-full items-center justify-between">
        <a href="/" class="header-logo text-primary hover:text-gold block">
            <logo-text class="w-44"></logo-text>
            <span class="sr-only">Pappas Restaurant Weeks 2026</span>
        </a>

        <button id="nav-toggle" type="button" class="cursor-pointer md:hidden" aria-controls="nav-drawer" :aria-label="hamburgerLabel" :aria-expanded="showNavigation" @click.prevent="showNavigation = !showNavigation">
            <svg v-if="!showNavigation" class="size-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75" d="M4 6h16M4 12h16M4 18h16" />
            </svg>

            <svg v-else class="size-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75" d="M6 18L18 6M6 6l12 12" />
            </svg>
        </button>
    </div>

    <div id="nav-drawer" :aria-hidden="!showNavigation" class="bg-primary fixed top-(--header-height-sm) bottom-0 z-99 w-full transition-all duration-250 aria-hidden:-translate-x-full aria-hidden:opacity-0">
        <div class="size-full max-h-full overflow-y-auto">
            <div class="flex min-h-full flex-col gap-y-12">
                <logo-banner-ext v-if="isExtensionPeriod" class="text-primary block h-auto w-full fill-[#FCB813]" aria-label="Extended to September 20 at select locations"></logo-banner-ext>
                <logo-banner v-else class="text-primary block h-auto w-full fill-[#FCB813]" aria-label="Benefiting your local food bank: August 1 to September 7"></logo-banner>

                <nav :class="[!showDonationAmount ? 'pb-8' : '', 'flex grow flex-col justify-center gap-y-8 px-8']">
                    <ul class="flex flex-col gap-y-8 text-center">
                        <li v-for="item in navigationItems" :key="`navItem-${item.id}`">
                            <a :href="item.url" class="font-modesto hover:text-gold aria-current:border-primary text-5xl text-white uppercase transition-colors duration-150 aria-current:border-b-4">
                                {{ item.label }}
                            </a>
                        </li>
                    </ul>

                    <div class="mt-6 flex justify-center">
                        <UiButton href="/reservations" large color="turquoise-dark" class="bg-turquoise-dark [&_svg]:text-white">Make a Reservation</UiButton>
                    </div>
                </nav>

                <div v-if="showDonationAmount" class="bg-gold-lighter flex justify-center px-8 py-6">
                    <div class="inline-flex flex-col">
                        <div class="flex items-baseline gap-x-1.5 text-[#596c80]">
                            <span class="font-caslon-ionic text-xl">${{ donationAmount }}</span>

                            <span class="font-filmotype pr-0.5 text-3xl">Raised</span>
                            <span class="h7 text-xs">And Counting!</span>
                        </div>
                        <div class="double-rule-turquoise"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { computed } from 'vue';
import UiButton from '../Ui/UiButton.vue';

defineProps({
    navigationItems: { type: Array, required: true },
    donationAmount: { type: String, required: true },
    showDonationAmount: { type: Boolean, default: false },
    isExtensionPeriod: { type: Boolean, default: false },
});

const showNavigation = ref(false);

const hamburgerLabel = computed(() => (showNavigation.value ? 'close site navigation' : 'show site navigation'));

watch(showNavigation, (value) => document.querySelector('body').classList.toggle('overflow-hidden', value));
</script>
